import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateFormat,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

/**
 * Created when we link a device to a patient with a MAC address.
 */
export default class ConnectedDeviceLinkedJournalEvent extends JournalEvent {
  static override type = "connected-device-linked-journal-event";

  /**
   * The mac address corresponding to the linked device.
   */
  @attr("string") declare macAddress: string;

  /**
   * The device id returned by Withings after a link request.
   * It is set automatically by the back.
   * This is usefull to retrieve the model or other informations about the device.
   */
  @attr("string") declare withingsDeviceId: string;

  static override validations(intl: IntlService) {
    return {
      macAddress: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.connected-device-linked-journal-event.mac-address"
          )
        }),
        validateFormat({
          regex: /^([0-9A-Fa-f]{2}:){5}([0-9A-Fa-f]{2})$/,
          description: intl.t(
            "validations.connected-device-linked-journal-event.mac-address"
          )
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.connected-device-linked-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "connectedDeviceLinkedJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "connected-device-linked-journal-event": ConnectedDeviceLinkedJournalEvent;
  }
}
